import React, { useImperativeHandle, useRef } from "react";
import { Grid } from "@mui/material";
import { MASK_TYPE, AutocompleteField, TextField } from "@curves/ui-base";
import { refIsRequiredError, getErrorModuleStatus } from "@util/utils";

/**
 * 跨店會員欄位組件
 * 用於輸入跨店會員的分店、姓名和手機號碼
 */
const CrossMemberField = React.forwardRef((props, ref) => {
	const { clubOptions, readOnly, errorModule = {} } = props;
	const clubRef = useRef(null);
	const nameRef = useRef(null);
	const telRef = useRef(null);

	useImperativeHandle(
		ref,
		() => ({
			getResult: () => {
				let result = {};
				if (clubRef.current && clubRef.current.getResult) {
					result.clubID = clubRef.current.getResult().value;
				}
				if (nameRef.current && nameRef.current.getResult) {
					result.receiverName = nameRef.current.getResult();
				}
				if (telRef.current && telRef.current.getResult) {
					result.receiverPhone = telRef.current.getResult();
				}
				return result;
			},
			isError: () => refIsRequiredError(clubRef, nameRef, telRef),
		}),
		// eslint-disable-next-line
		[],
	);

	return (
		<React.Fragment>
			<Grid xs={3} item>
				<AutocompleteField
					label="分店"
					ref={clubRef}
					options={clubOptions}
					optionKeys={["text"]}
					primaryKey="id"
					InputProps={{
						disabled: readOnly,
					}}
					fullWidth
					required
					{...getErrorModuleStatus(errorModule, "clubID")}
				/>
			</Grid>
			<Grid xs={3} item>
				<TextField label="姓名" ref={nameRef} disabled={readOnly} fullWidth required {...getErrorModuleStatus(errorModule, "receiverName")} />
			</Grid>
			<Grid xs={3} item>
				<TextField label="手機號碼" ref={telRef} maskType={MASK_TYPE.MOB} disabled={readOnly} fullWidth required  {...getErrorModuleStatus(errorModule, "receiverPhone")} />
			</Grid>
		</React.Fragment>
	);
});

CrossMemberField.displayName = "CrossMemberField";

export default CrossMemberField;

